import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { IconBolt, IconGive, IconHero, IconSnap, } from "components/Icon/UI";
import "./style.scss";
import useLanguageProvider from "components/LanguageProvider/hooks/useLanguageProvider";
const sellingPoints = [
    {
        icon: _jsx(IconBolt, { className: "icon bolt" }),
        body: "With Chuffed, you'll be able to access your donations almost instantly",
    },
    {
        icon: _jsx(IconGive, { className: "icon give" }),
        body: "Whether you’re a social enterprise, organisation, charity or individual, Chuffed is the best place to raise funds for your cause",
    },
    {
        icon: _jsx(IconSnap, { className: "icon snap" }),
        body: "Easily set up your campaign within minutes, plus you’ll have access to our guides and human support",
    },
    {
        icon: _jsx(IconHero, { className: "icon hero" }),
        body: "We’ve helped empower over 50,000 campaigners and local heroes to raise $300M+ since 2013",
    },
];
const SellingPoint = (point, i) => {
    const { translate: t } = useLanguageProvider();
    const { icon, body } = point;
    return (_jsxs("div", { className: "point", children: [_jsx("span", { children: icon }), _jsx("p", { children: t(body) })] }, `point-${i}`));
};
const OnboardingSellingPoints = () => (_jsx("div", { className: "selling-points", children: sellingPoints.map((point, i) => SellingPoint(point, i)) }));
export default OnboardingSellingPoints;
